import { io, Socket } from 'socket.io-client';

const API_BASE = import.meta.env.VITE_API_URL || '';

let socket: Socket | null = null;

export function connectSocket(token?: string): Socket {
  if (socket?.connected) return socket;

  socket = io(API_BASE || undefined, {
    path: '/ws',
    auth: token ? { token } : {},
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
  });

  socket.on('connect', () => {
    console.log('WebSocket connected');
  });

  socket.on('disconnect', (reason) => {
    console.log('WebSocket disconnected:', reason);
  });

  return socket;
}

export function getSocket(): Socket | null {
  return socket;
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = null;
}
